/**
 * @class CabinetCompareFilter
 *
 * Detail view for a cabinet filter whose definition declares `type: 'numericRange'`. Those
 * filters compare the indexed value instead of picking from a list, so this view holds only
 * the comparison controls — no options request, no search, and no value list.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import CompareFilterSection from '../common/filters/compareFilterSection';
import FilterDetailHeader from '../common/filters/filterDetailHeader';
import Icon from '../common/containers/icon';
import { getCompareEntry, withCompareEntry } from '../../utils/cabinetCompareFilters';
const CabinetCompareFilter = ({
  filterDefinition: {
    index,
    title
  },
  indexQuery,
  onBack,
  serverFilter
}) => {
  const entry = getCompareEntry(indexQuery.filters, index);
  const handleChange = nextEntry => {
    const nextFilters = withCompareEntry(indexQuery.filters, index, nextEntry);
    // A comparison and a list selection on the same index would contradict each other.
    delete nextFilters[index];
    serverFilter(nextFilters, indexQuery);
  };
  const clearButton = entry ? /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "link",
    className: "t-cf-compare-clear",
    "data-testid": "cabinet-compare-clear",
    onClick: () => handleChange(null)
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "times-circle",
    weight: "far"
  }), " Clear") : null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FilterDetailHeader, {
    title: title,
    onBack: onBack,
    action: clearButton
  }), /*#__PURE__*/React.createElement(CompareFilterSection, {
    title: title,
    index: index,
    entry: entry,
    onChange: handleChange
  }));
};
CabinetCompareFilter.propTypes = {
  filterDefinition: PropTypes.shape({
    index: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  // the current cabinet's indexQuery
  indexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  onBack: PropTypes.func.isRequired,
  // filters the cabinet index view; managed by cabinetFilterPanel.jsx
  serverFilter: PropTypes.func.isRequired
};
export default CabinetCompareFilter;